<p-button
    [label]="label() && !hideLabel() ? (label()! | translate) : null"
    [icon]="icon() ? 'pi ' + icon() : undefined"
    [iconPos]="iconPosition()"
    [styleClass]="btnClass()"
    [dt]="dt()"
    [size]="size()"
    [severity]="severity()"
    [disabled]="disabled()"
    [loading]="loading()"
    [text]="text()"
    [plain]="plain()"
    [rounded]="rounded()"
    [outlined]="outlined()"
    [title]="title()"
    (onClick)="onClick($event)"
>
    <ng-content></ng-content>
    @if (svgIcon()) {
        <ng-template pTemplate="icon">
            <svg-icon class="appBtn_svgIcon" [name]="svgIcon()"></svg-icon>
        </ng-template>
    }
</p-button>
